'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';

export const FormSelect = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathName = usePathname();
  const [tierValue, setTierValue] = useState<string>(
    searchParams.get('tier') || ''
  );
  const updateSearchParam = (key: string, value: string) => {
    // Create a new URLSearchParams instance with current params
    const params = new URLSearchParams(searchParams.toString());

    // Update or add the new key-value pair
    if (value) {
      params.set(key, value);
      params.set('page', '1');
    } else {
      // Remove the parameter if value is empty
      params.delete(key);
    }

    // Create the new URL using pathname instead of window.location
    const newUrl = `${pathName}?${params.toString()}`;

    // Use router.push to update the URL
    router.push(newUrl);
  };
  const handleSelection = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const tierValue = e.target.value;
    setTierValue(tierValue);
    updateSearchParam('tier', tierValue);
  };
  return (
    <Form.Select
      aria-label="Default select example"
      value={tierValue}
      onChange={handleSelection}
      aria-live="polite"
    >
      <option value="">All</option>
      <option value="Free">Free</option>
      <option value="Premium">Premium</option>
    </Form.Select>
  );
};
